import { createContext } from 'react';
import type { TrackEventArgs, TrackPageViewArgs } from './types';

export type TrackEventFn = (...args: TrackEventArgs) => void;

export type TrackPageViewFn = (...args: TrackPageViewArgs) => void;

type TrackingContextValue = {
  trackEvent: TrackEventFn;
  trackPageView: TrackPageViewFn;
};

export const TrackingContext = createContext<TrackingContextValue>({
  trackEvent: () => {
    throw new Error('trackEvent: TrackingProvider not found');
  },
  trackPageView: () => {
    throw new Error('trackPageView: TrackingProvider not found');
  },
});
